import { CalendarViewPageBase } from './CalendarViewPage.base';
import {
    CalendarViewPageProps,
    CalendarViewPageStyleProps,
    CalendarViewPageStyles,
} from './CalendarViewPage.types';
import { styled } from '@fluentui/react/lib/Utilities';

export { CalendarViewPageProps };

/** The default style of CalendarViewPage */
export function getStyles(
    styleProps: Required<CalendarViewPageStyleProps>
): CalendarViewPageStyles {
    return {
        root: ['ms-CalendarViewPage', styleProps.className],
        printView: {
            transform: 'scale(' + styleProps.calendarZoom + ')',
            transformOrigin: styleProps.isRTL ? '100% 0' : '0 0',
            width: 100 / styleProps.calendarZoom + '%',
            height: 100 / styleProps.calendarZoom + '%',
        },
    };
}

/** The default styled version of CalendarViewPage */
export const CalendarViewPage = styled<
    CalendarViewPageProps<{}>,
    Required<CalendarViewPageStyleProps>,
    CalendarViewPageStyles
>(CalendarViewPageBase, getStyles) as typeof CalendarViewPageBase;
